import { render, staticRenderFns } from "./OrderListItem.vue?vue&type=template&id=166c3579&scoped=true&"
import script from "./OrderListItem.vue?vue&type=script&lang=ts&"
export * from "./OrderListItem.vue?vue&type=script&lang=ts&"
import style0 from "./OrderListItem.vue?vue&type=style&index=0&id=166c3579&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166c3579",
  null
  
)

export default component.exports